import { render, staticRenderFns } from "./InformativeDialog.vue?vue&type=template&id=04bdb2bc&lang=pug&"
import script from "./InformativeDialog.vue?vue&type=script&lang=js&"
export * from "./InformativeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports